import React from 'react'

function payment() {
  return (
    <div className='wrap'>
        <img src="https://t3.ftcdn.net/jpg/04/07/44/62/360_F_407446284_KBEUJeBQWXwrPwRB7vh0CdAzT9VmXori.jpg"></img>
        
    </div>
  )
}

export default payment